import { IconButton } from '@mui/material';
import Latex from 'react-latex-next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';

// mui icons
import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';
import { AyudantiaState, setAyudantia } from '../../store/slices/ayudantia';
import CrearEjercicioAyudantia from './CrearEjercicioAyudantia';
import EditarEjercicioAyudantia from './EditarEjercicioAyudantia';

import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import EliminarEjercicioAyudantia from './EliminarEjercicioAyudantia';

const AyudantiasEdicion = () => {

  const dispatch = useDispatch<AppDispatch>();
  
  const { ayudantias, isLoading } = useSelector((state: RootState) => state.ayudantia);

  // Crear Ayudantia
  const [openCrear, setOpenCrear] = useState(false);

  const handleClickOpenCrear = () => {
    console.log('Crear Ejercicio')
    setOpenCrear(true);
  }

  // Eliminar Ayudantia
  const [openEliminar, setOpenEliminar] = useState(false);

  const handleClickOpenEliminar = (ayudantia: AyudantiaState) => {
    dispatch(setAyudantia(ayudantia));
    setOpenEliminar(true)
  }

  // Editar Ayudantia
  const [openEditar, setOpenEditar] = useState(false);

  const handleClickOpenEditar = (ayudantia: AyudantiaState) => {
    dispatch(setAyudantia(ayudantia));
    setOpenEditar(true)
  }

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-success" role="status">
            <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    )
  }

  return (
    <>

      {
        openCrear && <CrearEjercicioAyudantia open={openCrear} setOpen={setOpenCrear}/>
      }

      {
        openEditar && <EditarEjercicioAyudantia open={openEditar} setOpen={setOpenEditar}/>
      }

      {
        openEliminar && <EliminarEjercicioAyudantia open={openEliminar} setOpen={setOpenEliminar}/>
      }

      <div className="container mb-4">
        <div className="row justify-content-end align-items-center">
          <div className="col-auto px-1" >
            <IconButton
              onClick={handleClickOpenCrear}
              size="small"
            >
              <AddIcon />
            </IconButton>
          </div>
          <div className="col-auto px-1">
            <span style={{ color: 'grey' }}>Crear Ejercicio</span>
          </div>
        </div>
      </div>

      {
        ayudantias.map((item, index) => {
          const { id, enunciado } = item;
          return (
            <div className='card mb-4' key={id}>

              <div className="card-header py-2">

                <div className="row justify-content-between align-items-center">
                  <div className="col-auto">
                    Ejercicio {index+1}
                  </div>
                  <div className="col-auto">
                    <IconButton
                      onClick={() => handleClickOpenEditar(item)}
                      size='small'
                    >
                      <EditIcon fontSize="inherit" />
                    </IconButton>

                    <IconButton
                      onClick={() => handleClickOpenEliminar(item)}
                      size='small'
                    >
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                  </div>
                </div>

              </div>

              <div className="card-body">
                  <Latex>{enunciado}</Latex>
              </div>
            </div>
          )
        })
      }
    </>
  )
}

export default AyudantiasEdicion;